<tt-page *ngIf="!!setting">
    <tt-page-heading *ngIf="!!setting.webpage_heading" [ttModel]="setting.webpage_heading"></tt-page-heading>
    <tt-list class="col-xs-12 col-md-6 sp-0" [ttData]="itemsListOperationFactories"></tt-list>
</tt-page>
